import createCustomContext from '../../../contexts/create-custom-context.js';

const [LegacyAutocompleteInputContextProvider, useLegacyAutocompleteInputContext] = createCustomContext('LegacyAutocompleteInputContext', {
  optionsListVisible: false,
  value: ''
});

export { LegacyAutocompleteInputContextProvider, useLegacyAutocompleteInputContext };
